import React from 'react';
import { toast } from 'react-toastify';
import Demi from './demi.js';
import Inc from './include.js';

import './board.scss';

class BoardPage extends React.Component {
	mail= null;
	tid_interval = null;
	tid_timeout = null;
	history = [];
	check = true;
	alarm = 0;
	num_demi = 0;
	alarm_base = 0;
	names = [];
	visibility_key = null;
	guard = false;
	constructor(props){
		super(props);
		this.state = {
			step: 1,
			turn: 1,
			fuel: Inc.FUEL,
			demi: null,
			win: 0,
			selected: [],
			reason: [],
			yesno: true,
			shutter:false,
		};
	}

	componentDidMount (){
		this.addVisibility();
		this.getDemi( ()=>{
			this.alarm = Inc.FUEL-1;
			this.startClock();
		});
	}

	componentWillUnmount (){
		toast.dismiss();
		this.stopClock();
		this.stopTimeout();
		this.removeVisibility();
	}

	stopInterval (){
		if( this.tid_interval ){
			clearInterval( this.tid_interval );
			//console.log("stop interval");
		}
		this.tid_interval = null;
	}
	stopTimeout (){
		if( this.tid_timeout ){
			clearTimeout( this.tid_timeout );
			//console.log("stop timeout");
		}
		this.tid_timeout = null;
	}
	startClock (){
		if( this.tid_interval ){
			this.stopInterval();
		}
		const play = this.props.getPlay();
		this.alarm_base = 13-play.lv*3;

		this.tid_interval = setInterval( ()=>{
			this.setState({fuel:this.state.fuel-1});
			if( this.state.fuel===this.alarm ){
				//if( this.state.step===1 ){
					this.getMail();
					this.alarm -= Math.round(Math.random()*6)+this.alarm_base;
					//console.log("alarm:"+this.alarm);
				//} else {
				//	this.alarm -= 1;
				//}
			}
			if( this.state.fuel===0 ){
				this.goGoodEnd();
			}
		},1000);
	}
	stopClock (){
		this.stopInterval();
	}

	openMail (){
		toast.warning("青空のマリーから入電！");
		this.history.unshift( this.mail );
	}

	setMail (mail){
		this.mail = mail;
	}

	setDemi (demi){
		if( demi ){
			this.num_demi++;
		}
		this.setState({demi:demi,selected:[],yesno:true});
	}

	getMail (){
		const play = this.props.getPlay();
		//this.props.showLoading(true);
		this.props.ajax("mail/new",{play_id:play.id},(res)=>{
			//this.props.showLoading(false);
			if( res.ok ){
				this.setMail(res.mail);
				this.openMail();
			}
		});
	}

	getDemi (func){
		const play = this.props.getPlay();
		//console.log( play );
		this.props.showLoading(true);
		this.props.ajax("demi/new",{play_id:play.id},(res)=>{
			this.props.showLoading(false);
			//console.log( res );
			if( res.ok ){
				toast.info(res.demi.name + "がやってきました。");
				this.setDemi(res.demi);
				if( func ){
					func();
				}
			}
		});
	}

	render (){
		if(this.state.step===5){
			//失敗の理由
			return this.render_reason();
		} else {
			return this.render_question();
		}
	}

	render_question (){
		if(!this.state.demi){
			return (null);
		}
		const history = this.getHistory();

		let classname = "board";
		let yesclass = "yes";
		let noclass = "no";
		if( this.state.step===1 ){
			classname += " board_fadein";
		} else if( this.state.step>0 ){
			classname += " board_fadeout";
		}
		//if( this.state.selected.length===0 ){
		if( this.state.yesno ){
			noclass += " disabled";
		} else {
			yesclass += " disabled";
		}

		let clockclass = "fas fa-hourglass-half fa-fw fa-spin animated";
		if( this.alarm!==this.state.fuel ){
			if( this.alarm+1>=this.state.fuel ){
				clockclass += " notice1";
			} else if( this.alarm+3>=this.state.fuel ){
				clockclass += " notice2";
			}
		}

		return (
			<React.Fragment>
				<div id="board" className={classname}>
					<h2 className="fuel">
						<div className="left">通過者<span>{this.state.win}</span>人</div>
						<div className="right"><i className={clockclass}></i> 残り<span>{this.state.fuel}</span>秒</div>
					</h2>
					<Demi data={this.state.demi} step={this.state.step} setSelected={(arr)=>this.setSelected(arr)}/>
					{this.state.step===1 &&
					<React.Fragment>
					<div className="history" id="history">
						<h3><i className="fas fa-satellite-dish fa-fw"></i> マリーの通信履歴</h3>
						{this.history.length>0 &&
						<div className="paper">{history}</div>
						}
						{this.history.length===0 &&
						<div className="paper">まだ入電はない</div>
						}
						</div>
					<div className="bottom_btns">
						<button
							onClick={()=>this.goGate()}
							className={yesclass}
						><i className="fas fa-arrow-up"></i><br/>GO</button>
						<button
							onClick={()=>this.goAway()}
							className={noclass}
						><i className="fas fa-ban"></i><br/>STOP</button>
					</div>
					</React.Fragment>
					}
				</div>

				{this.state.step>2 &&
				<div id="board_full">
					{this.state.step>2 &&
					<div className="mark fan"><i className="fas fa-eye fa-fw fa-spin animated"></i></div>
					}

					{this.state.step===3 &&
					<div className="sheet result ok">
						<div className="mark">
							<i className="far fa-circle"></i><br/>
							<span>通過</span>
						</div>
					</div>
					}

					{this.state.step===4 &&
					<div className="sheet result ng">
						<div className="mark">
							<i className="fas fa-skull-crossbones"></i><br/>
							<span>失敗</span>
						</div>
						<div className="bottom_btns">
							<button
								onClick={()=>this.goReason()}
								className="one"
							><i className="fas fa-chess-rook"></i><br/>詳細を確認</button>
						</div>
					</div>
					}

				</div>
				}

				{this.state.shutter &&
				<div id="shutter">
					<div className="upper"></div>
					<div className="lower"></div>
					<div className="timeup">革命の時間です</div>
				</div>
				}
			</React.Fragment>
		)
	}

	render_reason (){
		if(!this.state.demi){
			return (null);
		}
		const history = this.getHistory();
		return (
			<div id="board">
				<h2 className="fuel">
					<div className="left">通過者<span>{this.state.win}</span>人</div>
					<div className="right"><i className="fas fa-hourglass-half fa-fw"></i> 残り<span>{this.state.fuel}</span>秒</div>
				</h2>
				<Demi data={this.state.demi} step={this.state.step} reason={this.state.reason}/>
				<div className="history" id="history">
					<h3><i className="fas fa-satellite-dish fa-fw"></i> マリーの通信履歴</h3>
					<div className="paper">{history}</div>
				</div>
				<div className="bottom_btns">
					<button
						onClick={()=>this.goBadEnd()}
						className="one"
					><i className="fas fa-mask"></i><br/>終わる</button>
				</div>
			</div>
		)
	}

	getHistory (){
		if( this.state.step!==1 && this.state.step!==5 ){
			return (null);
		}
		return this.history.map( (mail,index)=>{
			if( !mail.rule ){
				return (null);
			}
			const key = "mail"+index;
			let classname = "box";
			if( mail.turn===this.mail.turn ){
				classname += " new_box";
			}
			return (
				<div key={key} className={classname}>
					<div className="text">
						<div>
						{this.getNews(mail.rule)}
						</div>
					</div>
				</div>
			);
		});
	}

	getNews (rule){
		let text = "";
		if( rule.permit ){
			text = Inc.NEWS_TEXT2[rule.param_id][rule.text_id-1];
		} else {
			text = Inc.NEWS_TEXT1[rule.param_id][rule.text_id-1];
		}
		return text.replace(/\[NAME\]/g,Inc.TYPE_NAMES[rule.param_id][rule.type_id]);
	}

	addVisibility (){
		var hidden, visibilityChange;
		if (typeof document.hidden !== "undefined") {
			hidden = "hidden";
			visibilityChange = "visibilitychange";
		} else if (typeof document.webkitHidden !== "undefined") {
			hidden = "webkitHidden";
			visibilityChange = "webkitvisibilitychange";
		} else {
			this.visibility_key = handler.addListener(window, 'blur', ()=>{
				this.blur();
			},false);
			return;
		}

		this.visibility_key = handler.addListener(document, visibilityChange, ()=>{
			if( this.play_id===0 ){
				return;
			}
			if ( document[hidden] ) {
				this.blur();
			} else {
				//this.focus();
			}
		}, false);
	}

	removeVisibility (){
		if( this.visibility_key!==null ){
			handler.removeListener( this.visibility_key );
		}
	}

	blur (){
		toast.dismiss();

		this.stopClock();
		this.stopTimeout();
		this.removeVisibility();

		this.props.clearMessage();
		this.props.addMessage("コリー、コリー、起きてる？\n目を離しちゃダメ！");
		this.props.showAlert( ()=>{
			this.finish();
		});
	}

	focus (){
		//console.log("focus");
	}

	goBadEnd (){
		this.stopClock();
		this.stopTimeout();
		//this.props.setState({mode:"badend"});
		this.props.setData({list:this.names,last:this.state.demi.name});
		this.props.openModal("badend",()=>{
			//this.finish();
			this.props.setState({mode:"result"});
		});
	}

	goGoodEnd (){
		this.stopClock();
		this.stopTimeout();
		this.setState({shutter:true});
		const play = this.props.getPlay();
		this.props.ajax("play/success",{play_id:play.id},(res)=>{
			this.tid_timeout = setTimeout( ()=>{
				this.props.setData({list:this.names});
				this.props.openModal("goodend",()=>{
					this.props.setState({mode:"result",play:res.play});
				});
			},1000);
		});
	}

	goGate (){
		if( !this.state.yesno ){
			toast.error("バツがついてるのに？");
			return;
		}
		if( this.guard ){
			return;
		}
		console.log("go gate");
		this.guard = true;

		const play = this.props.getPlay();
		let turn = 0;
		if( this.mail ){
			turn = this.mail.turn;
		}
		this.stopTimeout();
		this.props.showLoading(true);
		this.props.ajax("demi/check",{play_id:play.id,turn:turn,demi_id:this.state.demi.id},(res)=>{
			this.props.showLoading(false);
			//console.log(res);
			if( res.ok ){
				console.log( res );
				if( !res.check ){
					this.stopClock();
					this.props.setState({play:res.play});
					this.setState({step:4,reason:res.reason});
				} else {
					this.names.push( this.state.demi.name );
					//this.props.setState({play:res.play});
					this.setState({step:3,win:this.state.win+1});
					this.tid_timeout = setTimeout( ()=>{
						this.setDemi(null);
						this.goNext();
					},1500);
				}
				this.guard = false;
			}
		});
	}

	goAway (){
		//最低一つはチェックされてないとダメ
		//if( this.state.selected.length===0 ){
		if( this.state.yesno ){
			toast.error("どこが悪いのか教えてあげて！");
			return;
		}
		const play = this.props.getPlay();
		this.props.showLoading(true);
		this.props.ajax("demi/change",{play_id:play.id,demi_id:this.state.demi.id,selected:this.state.selected},(res)=>{
			this.props.showLoading(false);
			//console.log(res);
			if( res.ok ){
				this.setState({step:2});
				this.tid_timeout = setTimeout( ()=>{
					this.setDemi(null);
					this.goNext();
				},750);
			}
		});
	}

	goReason (){
		this.setState({step:5});
	}

	goNext (){
		this.stopTimeout();
		this.getDemi( ()=>{
			this.setState({step:1});
		});
	}

	finish (){
		//this.props.setState({mode:'top',result_key:null,play:null});
		this.props.goTop();
	}

	setSelected (selected){
		let yesno = true;
		for( let i=0; i<selected.length ; i++ ){
			if( selected[i] ){
				yesno = false
			}
		}
		this.setState({selected:selected,yesno:yesno});
	}
}

var handler = (function(){
    let events = {};
    let key = 0;
     return {
        addListener: function(target, type, listener, capture) {
            target.addEventListener(type, listener, capture);
            events[key] = {
                target: target,
                type: type,
                listener: listener,
                capture: capture
            };
            return key++;
        },
        removeListener: function(key) {
            if(key in events) {
                var e = events[key];
                e.target.removeEventListener(e.type, e.listener, e.capture);
            }
        }
    };
}());

export default BoardPage;